import API_BASE_URL from "./apiBase";
import { ADMIN_TOKEN_KEY } from "./projects";

// RM (relationship manager) accounts — admin only. Each call sends the admin
// token issued at login; the backend rejects anyone else.
const request = async (path, { method = "GET", body } = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/user/rms${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ADMIN_TOKEN_KEY) || ""}`,
    },
    ...(body && { body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || "Request failed");
  return data;
};

export const listRms = () => request("");
export const createRm = (rm) => request("", { method: "POST", body: rm });
export const resetRmPassword = (id, password) =>
  request(`/${id}/password`, { method: "PATCH", body: { password } });
export const deleteRm = (id) => request(`/${id}`, { method: "DELETE" });

// "Rahul Sharma" -> "rahul.sharma"
export const suggestUsername = (name = "") =>
  name
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^\w\s.-]/g, "")
    .replace(/\s+/g, ".")
    .slice(0, 40);

// Easy to read aloud or type from a phone: no 0/O, 1/l/I look-alikes.
const ALPHABET = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const generatePassword = (length = 10) => {
  const bytes = new Uint32Array(length);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (n) => ALPHABET[n % ALPHABET.length]).join("");
};
